module.exports = __webpack_public_path__ + "static/media/utilita3.06ce0f74.png";